/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Layer } from './layer';
import { LayerPattern } from './layerPattern';


export interface Pallet { 
    /**
     * Type of pallet
     */
    palletType?: Pallet.PalletTypeEnum;
    /**
     * Pallet length (mm).
     */
    length?: number;
    /**
     * Pallet width (mm).
     */
    width?: number;
    /**
     * Pallet overhang for pallet left side (mm)
     */
    overhangL?: number;
    /**
     * Pallet overhang for pallet top side (mm)
     */
    overhangT?: number;
    /**
     * Pallet overhang for pallet right side (mm)
     */
    overhangR?: number;
    /**
     * Pallet overhang for pallet bottom side (mm)
     */
    overhangB?: number;
    layerPatterns?: Array<LayerPattern>;
    layers?: Array<Layer>;
    /**
     * Where to place interlayer sheets. Position 0 is between pallet and the bottom layer. Position n is on top of layer number n.
     */
    interlayerSheetPositions?: Array<boolean>;
    /**
     * Interlayer sheets thickness in mm.
     */
    interlayerThickness?: number;
    /**
     * Pallet height (mm)
     */
    height?: number;
    /**
     * Rotation of the pallet view
     */
    displayRotation?: number;
}
export namespace Pallet {
    export type PalletTypeEnum = 'EUR' | 'INDU' | 'US' | 'JP' | 'AU' | 'IL' | 'CHEM' | 'CUSTOM';
    export const PalletTypeEnum = {
        EUR: 'EUR' as PalletTypeEnum,
        INDU: 'INDU' as PalletTypeEnum,
        US: 'US' as PalletTypeEnum,
        JP: 'JP' as PalletTypeEnum,
        AU: 'AU' as PalletTypeEnum,
        IL: 'IL' as PalletTypeEnum,
        CHEM: 'CHEM' as PalletTypeEnum,
        CUSTOM: 'CUSTOM' as PalletTypeEnum
    };
}


